<template>
    <div>
        <kgr-loading v-if="loading" />
        <editor
            v-if="showHeaderBox"
            :id="headerEditorId"
            :value="header"
            :init="initEditor(this, false, '200px', 'H')"
            @onChange="onHeaderChange"
            @onInit="loadingHeader = false"
        />
        <editor
            :id="editorId"
            :value="content"
            :init="initEditor(this, !mini)"
            @onChange="onContentChange"
            @onInit="loadingContent = false"
        />
        <editor
            v-if="showFooterBox"
            :id="footerEditorId"
            :value="footer"
            :init="initEditor(this, false, '200px', 'F')"
            @onChange="onFooterChange"
            @onInit="loadingFooter = false"
        />
    </div>
</template>

<script>
import 'tinymce/tinymce';
import 'tinymce/themes/silver';
import 'tinymce/icons/default/icons';
import 'tinymce/plugins/link/plugin';
import 'tinymce/plugins/lists/plugin';
import 'tinymce/plugins/table/plugin';
import 'tinymce/models/dom';
import Editor from '@tinymce/tinymce-vue';
import Loading from './common/Loading';
import tinymce from 'tinymce';

export default {
    components: {
        'kgr-loading': Loading,
        'editor': Editor,
    },
    props: {
        locale: {
            type: String,
            required: false,
            default: 'de_DE'
        },
        contentSelector: {
            type: String,
            required: false,
            default: null
        },
        editorId: {
            type: String,
            required: false,
            default: 'kgreditor'
        },
        height: {
            type: String,
            required: false,
            default: '500px',
        },
        width: {
            type: String,
            required: false,
            default: '100%',
        },
        format: {
            type: String,
            validator: prop => ['DINA4', null].includes(prop),
            required: false,
            default: null,
        },
        mini: {
            type: Boolean,
            required: false,
            default: false,
        },
        fontSizeUnit: {
            type: String,
            required: false,
            default: 'pt',
        },
        headerSelector: {
            type: String,
            required: false,
            default: null
        },
        headerEditorId: {
            type: String,
            required: false,
            default: 'kgrheadereditor'
        },
        showHeader: {
            type: Boolean,
            required: false,
            default: false,
        },
        footerSelector: {
            type: String,
            required: false,
            default: null
        },
        footerEditorId: {
            type: String,
            required: false,
            default: 'kgrfootereditor'
        },
        showFooter: {
            type: Boolean,
            required: false,
            default: false,
        },
        placeholderSelection: {
            type: String,
            required: false,
            default: 'system'
        },
        resizable: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data() {
        return {
            loadingHeader: true,
            loadingContent: true,
            loadingFooter: true,
            placeholders: [],
            pageNumberPlaceholders: [
                {key: 'page_number', trans: this.$t('Seitenzahl')},
                {key: 'page_number_start_at_second_page', trans: this.$t('Seitenzahl ab der zweiten Seite')},
                {key: 'total_page_number', trans: this.$t('Anzahl Gesamt')},
            ],

            content: '',
            contentTarget: null,
            fonts: [
                'Arial',
                'Archivo Narrow',
                'Arimo',
                'Assistant',
                'Baloo Tammudu',
                'Barlow Semi Condensed',
                'Cardo',
                'Cormorant',
                'Cuprum',
                'Darker Grotesque',
                'Didact Gothic',
                'Harmattan',
                'Heebo',
                'Kalam',
                'Krub',
                'Lato',
                'Montserrat',
                'Noto Sans',
                'Open Sans',
                'Roboto',
                'Sans-Serif',
                'Serif',
                'Source Sans Pro',
                'Titillium Web',
            ],
            fontSizeFormats:  '8' + this.fontSizeUnit +
                ' 10' + this.fontSizeUnit +
                ' 12' + this.fontSizeUnit +
                ' 14' + this.fontSizeUnit +
                ' 16' + this.fontSizeUnit +
                ' 18' + this.fontSizeUnit +
                ' 20' + this.fontSizeUnit +
                ' 24' + this.fontSizeUnit +
                ' 36' + this.fontSizeUnit,

            header: '',
            headerTarget: null,
            showHeaderBox: this.showHeader,

            footer: '',
            footerTarget: null,
            showFooterBox: this.showFooter,
        }
    },
    computed: {
        loading() {
            return (this.loadingHeader && this.showHeaderBox) ||  this.loadingContent || (this.loadingFooter && this.showFooter);
        },
        fontTypes() {
            let fontString = '';
            this.fonts.forEach(function (font) {
                fontString += font + '=' + font + ';';
            });
            return fontString;
        }

    },
    mounted() {
        if (this.contentSelector) {
            this.contentTarget = $(this.contentSelector);
            this.contentTarget.hide();
            this.content = this.contentTarget.val();
        }
        if (this.headerSelector) {
            this.headerTarget = $(this.headerSelector);
            this.headerTarget.hide();
            this.header = this.headerTarget.val();
        }
        if (this.footerSelector) {
            this.footerTarget = $(this.footerSelector);
            this.footerTarget.hide();
            this.footer = this.footerTarget.val();
        }
        if (!this.mini) {
            this.placeholders = window.placeholders;
            this.placeholders.sort(function (a, b) {
                a = a.trans.toLowerCase();
                b = b.trans.toLowerCase();
                return a === b ? 0 : (a < b ? -1 : 1);
            });
            this.placeholderSections = this.getPlaceholderSections();
        }

        // disable tooltips for toolbar's menu items
        $(document).on('mouseover', '.tox-collection__group', function(event) {
            event.target.title = ''
        })
    },
    methods: {
        onContentChange(event) {
            if (this.contentTarget) {
                this.contentTarget.val(this.cleanOutput(event.target.getContent()));
            }
        },
        onHeaderChange(event) {
            if (this.headerTarget) {
                this.headerTarget.val(this.cleanOutput(event.target.getContent()));
            }
        },
        onFooterChange(event) {
            if (this.footerTarget) {
                this.footerTarget.val(this.cleanOutput(event.target.getContent()));
            }
        },
        cleanOutput(content) {
            let regex = new RegExp('(<span[^>]+\\sdata-placeholder\\b[^>]*>).+?<\\/span>','gm');
            return content.replace(regex, '$1</span>');
        },
        getEditor(editorId) {
            return tinymce.get(editorId);
        },
        getPlaceholderSections() {
            let sections = this.placeholders.map(placeholder => placeholder.section).filter(function (value, index, self) {
                return self.indexOf(value) === index;
            });

            sections.sort(function (a, b) {
                a = a.toLowerCase();
                b = b.toLowerCase();
                return a === b ? 0 : (a < b ? -1 : 1);
            });

            return sections;
        },
        createPlaceholder(key) {
            let placeholders = this.placeholders.concat(this.pageNumberPlaceholders)
            let placeholder = placeholders.find(placeholder => placeholder.key === key);
            let $span = $('<span class="draft-placeholder"></span>&nbsp;');
            $span
                .attr('data-trans', placeholder.trans)
                .attr('data-placeholder', key)
                .html(placeholder.trans)
                .attr('contenteditable', false);

            return $span.prop('outerHTML');
        },
        initEditor(kgrEditor, isContent, height = kgrEditor.height, type = null) {
            const isHeader = type === 'H';
            const isFooter = type === 'F';
            const kgrTranslations = {
                placeholderButtonText: this.$t('Platzhalter'),
                pageNumberButtonText: this.$t('Seitenzahl'),
                headerFooterButtonText: this.$t('Kopf- und Fußzeile'),
                headerMenuItem: this.$t('Kopfzeile einfügen'),
                footerMenuItem: this.$t('editor.toolbar.headerfooter.footer'),
                totalPageNumberButtonText: this.$t('Anzahl Gesamt'),
                pageNumberStartsAtSecondPage: this.$t('Seitenzahl ab der zweiten Seite'),
            };
            const plugins = ['link', 'lists'];
            if(!kgrEditor.mini) {
                plugins.push('table');
                if(isContent) {
                    plugins.push('pagebreak');
                }
            }

            let dinA4Styles = '';
            let editorWidth = kgrEditor.width;
            let editorFormat = this.format;

            if(editorFormat === 'DINA4') {
                let bodyMargin = '10mm 0';
                let bodyPadding = '27mm 25mm';
                if(isHeader) {
                    bodyMargin = '10mm 0 0 0';
                    bodyPadding = '9mm 25mm 0 25mm';
                } else if(isFooter) {
                    bodyMargin = '0 0 10mm 0';
                    bodyPadding = '0 25mm 9mm 25mm';
                }
                dinA4Styles = 'body { \n' +
                    'margin: '+ bodyMargin + '; \n' +
                    'border:1px solid #efefef;  \n' +
                    'width: 210mm;  \n' +
                    'padding:'+bodyPadding+'; \n' +
                    'background-color:white; \n' +
                    'box-sizing: border-box;  \n' +
                    'box-shadow: 0 4px 7px rgba(0, 0, 0, .6) } \n' +
                    '*, *::before, *::after {box-sizing: inherit;} \n'
                ;
                editorWidth = '240mm';
            }

            return {
                license_key: 'gpl',
                style_formats_merge: true,
                entity_encoding : 'raw',
                height: height,
                convert_urls: false,
                width: editorWidth,
                skin: 'oxide',
                skin_url: '/css/tinymce/oxide',
                menubar: false,
                language: kgrEditor.locale !== 'en_GB' ? kgrEditor.locale : null,
                language_url: kgrEditor.locale !== 'en_GB' ? ('/css/tinymce/langs/' + kgrEditor.locale + '.js') : null,
                statusbar: kgrEditor.resizable,
                resize: kgrEditor.resizable,
                branding: false,
                elementpath: false,
                formats: {
                    underline: { inline: 'u'},
                },
                font_size_formats: kgrEditor.fontSizeFormats,
                font_family_formats: kgrEditor.fontTypes,
                block_formats: 'Paragraph=p;Header 1=h1;Header 2=h2;Header 3=h3;Header 4=h4;Header 5=h5;Header 6=h6',
                extended_valid_elements : 'span[contenteditable|data-placeholder|align<center?justify?left?right|class|dir<ltr?rtl|id|lang|onclick|ondblclick|onkeydown|onkeypress|onkeyup|onmousedown|onmousemove|onmouseout|onmouseover|onmouseup|style|title]',
                verify_html: false,
                custom_elements: 'draft-placeholder',
                content_css: '/css/fonts.css',
                content_style: '.draft-placeholder {\n' +
                    '    border: 1px solid #aaaaaa;\n' +
                    '    padding: 0px 4px;\n' +
                    '    border-radius: 12px;\n' +
                    '} \n' +
                    'table td, table th {height: 21px; padding:4px} \n' +
                    dinA4Styles + ' \n' +
                    'table p {margin: 0} \n' +
                    '.table-no-border:not([border="1"]), .table-no-border:not([border="1"]):not([style*="border-style: solid"]) td, .table-no-border:not([border="1"]):not([style*="border-style: solid"]) th {border:1px dashed #bbb} \n' +
                    'body { font-family: Arial; font-size: 10' + kgrEditor.fontSizeUnit + ';}',
                plugins: plugins,
                pagebreak_separator: '<pagebreak>',
                contextmenu: false,
                toolbar_mode: 'wrap',
                table_toolbar: 'tableprops tablerowprops tablecellprops tabledelete | tableinsertrowbefore tableinsertrowafter tabledeleterow | tableinsertcolbefore tableinsertcolafter tabledeletecol',
                table_advtab: true,
                table_cell_advtab: true,
                table_row_advtab: true,
                table_appearance_options: false,
                table_use_colgroups: false,
                table_default_styles: {
                    width: '100%',
                    'border-collapse': 'collapse',
                    'border-width': '1px',
                },
                table_default_attributes: {
                    cellPadding: '0',
                    cellSpacing: '0',
                    border: '0',
                    class: 'table-no-border'
                },
                table_border_styles: [
                    { title: 'Linie', value: 'solid' },
                ],
                table_border_widths: [
                    { title: 'small', value: '1px' },
                    { title: 'medium', value: '3px' },
                    { title: 'large', value: '5px' },
                ],
                setup : function(editor) {
                    let currentPlaceholderId = null;
                    const isSpecialHandlingRequired = (command) => {
                        const textFormatCommands = [
                            'mceToggleFormat',
                            'mceApplyTextcolor',
                            'mceRemoveTextcolor',
                            'FontName',
                            'FontSize'
                        ];
                        return textFormatCommands.indexOf(command) !== -1
                    };
                    const getPlaceholderBySelectionOrNull = (editor) => {
                        const selectedNode = editor.selection.getNode();
                        let currentElementIsPlaceholder = $(selectedNode).hasClass('draft-placeholder');
                        if(currentElementIsPlaceholder) {
                            return selectedNode;
                        }
                        const outer = $(selectedNode);
                        const inner = outer.children().first();
                        currentElementIsPlaceholder = (
                            outer.contents().length === 1 &&
                            inner.is('span') &&
                            inner.hasClass('draft-placeholder')
                        );
                        if(currentElementIsPlaceholder) {
                            return inner[0];
                        }
                        return null;
                    };
                    if (!kgrEditor.mini) {
                        editor.ui.registry.addMenuButton('placeholderButton', {
                            title: kgrTranslations.placeholderButtonText,
                            text: kgrTranslations.placeholderButtonText,
                            fetch: function (callback) {
                                var items = []
                                for (let i in kgrEditor.placeholderSections) {
                                    items.push({
                                        type: 'nestedmenuitem',
                                        text: kgrEditor.placeholderSections[i],
                                        getSubmenuItems: (function () {
                                            return kgrEditor.placeholders
                                                .filter(placeholder => placeholder.section === kgrEditor.placeholderSections[i])
                                                .map(placeholder => {
                                                    return {
                                                        type: 'menuitem',
                                                        text: placeholder.trans,
                                                        onAction: function () {
                                                            editor.insertContent(kgrEditor.createPlaceholder(placeholder.key));
                                                        }
                                                    }
                                                });
                                        })
                                    });
                                }
                                callback(items);
                            }
                        });

                        if (isContent && !kgrEditor.mini) {
                            editor.ui.registry.addMenuButton('headerFooterButton', {
                                text: kgrTranslations.headerFooterButtonText,
                                fetch: function (callback) {
                                    let items = [
                                        {
                                            type: 'togglemenuitem',
                                            text: kgrTranslations.headerMenuItem,
                                            onAction: function () {
                                                kgrEditor.showHeaderBox = !kgrEditor.showHeaderBox;
                                                if (!kgrEditor.showHeaderBox) {
                                                    kgrEditor.headerTarget.val('');
                                                }
                                            },
                                            onSetup: function (api) {
                                                api.setActive(kgrEditor.showHeaderBox);
                                                return function () {
                                                };
                                            }
                                        },
                                        {
                                            type: 'togglemenuitem',
                                            text: kgrTranslations.footerMenuItem,
                                            onAction: function () {
                                                kgrEditor.showFooterBox = !kgrEditor.showFooterBox;
                                                if (!kgrEditor.showFooterBox) {
                                                    kgrEditor.footerTarget.val('');
                                                }
                                            },
                                            onSetup: function (api) {
                                                api.setActive(kgrEditor.showFooterBox);
                                                return function () {
                                                };
                                            }
                                        },
                                    ];
                                    callback(items);
                                }
                            });
                        } else {
                            editor.ui.registry.addSplitButton('pageNumber', {
                                title: kgrTranslations.pageNumberButtonText,
                                text: kgrTranslations.pageNumberButtonText,
                                onAction: function () {
                                    editor.insertContent(kgrEditor.createPlaceholder('page_number'))
                                },
                                onItemAction: function (api, value) {
                                    editor.insertContent(value);
                                },
                                fetch: function (callback) {
                                    var items = [];
                                    items.push({
                                        type: 'choiceitem',
                                        text: kgrTranslations.pageNumberStartsAtSecondPage,
                                        value: kgrEditor.createPlaceholder('page_number_start_at_second_page')
                                    });
                                    items.push({
                                        type: 'choiceitem',
                                        text: kgrTranslations.totalPageNumberButtonText,
                                        value: kgrEditor.createPlaceholder('total_page_number')
                                    });
                                    callback(items);
                                }
                            });
                        }
                    }

                    editor.on('init', function (kgrEditor) {
                        if(editorFormat === 'DINA4') {
                            const iframe = kgrEditor.target.iframeElement;
                            iframe.style.width = '230mm';
                            iframe.style.margin = '0 0 0 10mm';
                            iframe.style.overflow = 'auto';
                        }
                    });

                    editor.on('TableModified', function (e) {
                        const temp = document.createElement('table');
                        const styleAttr = e.table.getAttribute('style');
                        if (styleAttr) {
                            temp.setAttribute('style', styleAttr);
                        }
                        document.body.appendChild(temp);
                        const borderStyle = $(temp).css('border-style'); // Get the computed style using jQuery
                        document.body.removeChild(temp);

                        if(borderStyle === 'none') {
                            e.table.removeAttribute('border');
                        }
                    });

                    // with attribute "contenteditable" tinymce does not wrap formatting spans around our placeholders.
                    // registering an event before certain commands run that removes "contenteditable" temporarilly
                    // is a workaround
                    // START workaround
                    editor.on('BeforeSetContent', function (e) {
                        // set initial span-tag content for placeholders
                        let regex = new RegExp('(<span[^>]+data-placeholder\\b\\="([^"]*)"[^>]*>)<\\/span>','gm');
                        e.content = e.content.replace(regex, function(match, part1, part2) {
                            let placeholders = kgrEditor.placeholders.concat(kgrEditor.pageNumberPlaceholders)
                            let placeholder = placeholders.find(placeholder => placeholder.key === part2);
                            if(!placeholder) {
                                return match;
                            }

                            return $(match).html(placeholder.trans).prop('contenteditable', false).prop('outerHTML');
                        });

                        // replace all <o:p> tags with its content
                        e.content = e.content.replace(/<o:p>(.*?)<\/o:p>/g, function(match, content) {
                            return content;
                        });

                        // remove text-indent from MsoListParagraph* styles
                        e.content = e.content.replace(/<p([^>]*class="[^"]*MsoListParagraph[^"]*"[^>]*)style="([^"]*)"([^>]*)>/gi, function(match, before, style, after) {
                            // Merge existing styles with text-indent: 0
                            function mergeStyles(existing, toAdd) {
                                const styleMap = {};
                                (existing + ';' + toAdd).split(';').forEach(function(s) {
                                    const parts = s.split(':');
                                    if (parts.length === 2) {
                                        styleMap[parts[0].trim()] = parts[1].trim();
                                    }
                                });
                                return Object.entries(styleMap).map(([k, v]) => `${k}: ${v}`).join('; ');
                            }
                            const newStyle = mergeStyles(style, 'text-indent: 0');
                            return `<p${before}style="${newStyle}"${after}>`;
                        });
                    });
                    editor.on('BeforeExecCommand', function (e) {
                        if(e.command === 'mceFocus') {
                            return;
                        }
                        // The commands we want to permit formatting noneditable items for
                        const placeholderBySelection = getPlaceholderBySelectionOrNull(editor);
                        $(editor.getBody()).find('span.draft-placeholder').removeAttr('contenteditable');
                        editor.nodeChanged();
                        if(placeholderBySelection === null) {
                            currentPlaceholderId = null;
                            return;
                        }
                        if (!isSpecialHandlingRequired(e.command)) {
                            return;
                        }

                        if(placeholderBySelection.getAttribute('id') === null) {
                            // we need to add an id to refetch this node later in `ExecCommand`:
                            // Initially (with no spans around the placeholder) the selected node gets deleted and rebuild
                            // after a styling-span has been wrapped around it.
                            const uniqueId = Math.random().toString(36).substr(2, 9);
                            placeholderBySelection.setAttribute('id', uniqueId);
                        }
                        currentPlaceholderId = placeholderBySelection.getAttribute('id');
                        editor.nodeChanged();
                    });
                    editor.on('ExecCommand', function (e) {
                        if(e.command === 'mceFocus') {
                            return;
                        }
                        let currentElement = null;
                        if(currentPlaceholderId) {
                            currentElement = editor.getDoc().getElementById(currentPlaceholderId);
                            if(!currentElement) {
                                console.error('--- currentElement is null, trying to find it by id failed');
                                return;
                            }
                        }

                        // collect styles and add them to html-table-generating classholder spans
                        const placeholderSpans = editor.selection.getNode().querySelectorAll('span.draft-placeholder');
                        const getInlineStyle = ((el,prop) => {
                            for (var i = 0, l = el.style.length; i < l; i++) {
                                let inlineStyleProp = el.style[i];
                                if(prop === inlineStyleProp) {
                                    return $(el).css(inlineStyleProp);
                                }
                            }
                            return null;
                        });
                        placeholderSpans.forEach((placeholderSpan) => {
                            const placeholderKey = $(placeholderSpan).data('placeholder');
                            const placeholder = kgrEditor.placeholders.find(placeholder => placeholder.key === placeholderKey);
                            if(!placeholder || !placeholder.hasTable) {
                                // if the placeholder does not have a table, we do not need to add styles
                                return;
                            }
                            const $placeholderSpan = $(placeholderSpan);
                            const styleElements = $placeholderSpan.parents('strong,em,u');
                            const cssStyles = {};
                            placeholderSpan.removeAttribute('style');
                            if($(styleElements).is('u')) {
                                cssStyles['text-decoration'] = 'underline';
                            }
                            if($(styleElements).is('em')) {
                                cssStyles['font-style'] = 'italic';
                            }
                            if($(styleElements).is('strong')) {
                                cssStyles['font-weight'] = 'bold';
                            }

                            const tableSurroundingSpans = $placeholderSpan.parents('span').get().reverse(); //ensure that the outermost span is the first one
                            tableSurroundingSpans.forEach(span => {
                                for (let i = 0, l = span.style.length; i < l; i++){
                                    const inlineStyleProp = span.style[i];
                                    const spanValue = $(span).css(inlineStyleProp);
                                    const currentValue = getInlineStyle(placeholderSpan, inlineStyleProp);
                                    if(currentValue === null) {
                                        cssStyles[inlineStyleProp] = spanValue;
                                    }
                                }
                            })
                            //convert cssStyles to a string
                            const stylesAsString = Object.entries(cssStyles).map(([key, value]) => `${key}: ${value}`).join(';');
                            placeholderSpan.setAttribute('style', stylesAsString);
                            placeholderSpan.setAttribute('data-mce-style', stylesAsString);
                            editor.nodeChanged();
                        })

                        if(currentElement !== null) {
                            editor.selection.collapse(true);
                            currentElement.setAttribute('contenteditable', false);

                            editor.focus();
                            editor.selection.select(currentElement)
                        }

                        $(editor.getBody()).find('span.draft-placeholder').attr('contenteditable', false);
                        // Trigger TinyMCE intern, um UI zu aktualisieren
                        editor.nodeChanged();
                    });
                },
                init_instance_callback: function (editor) {
                    // disable iframe's tooltip "Rich-Text-Bereich. Drücken Sie Alt+0 für Hilfe."
                    editor.iframeElement.title = '';

                    /*
                      The following two hacks fix some weirdness with the way the textcolor
                      plugin works - namely, it was attemping to apply color and background-color
                      directly on the element that had the noneditable css class on it instead of putting
                      a span around it as e.g. *underline* does.
                    */
                    editor.formatter.get('forecolor')[0].exact = true;
                    editor.formatter.get('hilitecolor')[0].exact = true;

                    // END workaround
                },
                toolbar: 'styles | bold italic underline forecolor | alignleft aligncenter alignright alignjustify | link bullist numlist outdent indent | fontfamily | fontsize'.concat(kgrEditor.mini ? '' : ' | table | placeholderButton | '.concat(isContent ? 'pagebreak | headerFooterButton' : 'pageNumber')),
                paste_preprocess: function(plugin, args) {
                    const allowedFonts = kgrEditor.fonts.map(font => font.toLowerCase());
                    function getValidFont(fontNames) {
                        if (!fontNames) return false;

                        // Split by comma and process each font
                        const fonts = fontNames.split(',').map(font => font.trim().replace(/['"]/g, '').toLowerCase());
                        for (const font of fonts) {
                            const isValid = allowedFonts.some(allowed =>
                                font === allowed || font.includes(allowed) || allowed.includes(font)
                            );

                            if (isValid) {
                                return font; // Return the first valid font found
                            }
                        }

                        return false;
                    }

                    const tempDiv = document.createElement('div');
                    tempDiv.innerHTML = args.content;
                    // Find all font elements
                    const fontElements = tempDiv.querySelectorAll('font[face]');

                    fontElements.forEach(function(fontElement) {
                        const fontFace = fontElement.getAttribute('face');

                        const validFont = getValidFont(fontFace);
                        if (validFont === false) {
                            const parent = fontElement.parentNode;
                            while (fontElement.firstChild) {
                                parent.insertBefore(fontElement.firstChild, fontElement);
                            }
                            parent.removeChild(fontElement);
                        } else {
                            fontElement.setAttribute('face', validFont);
                        }
                    });
                    args.content = tempDiv.innerHTML;
                    args.content = args.content.replace(/font-family\s*:\s*([^;"']+|(['"])(.*?)\2)/gi, function(match, fontFamily) {
                        const validFont = getValidFont(fontFamily);
                        if(validFont === false) {
                            // If no allowed font is found, remove style
                            return '';
                        }
                        return match;
                    });
                }
            };
        }
    },
}
</script>
